import React, { useState, useEffect } from "react";
import { keys, forEach, isEmpty, floor, round, includes, reduce } from "lodash";
import { findIndex } from "lodash";
import { Row, Col, Button, Modal, List, Input, Tooltip, Spin, DatePicker } from "antd";
import { CheckCircleOutlined, EditOutlined } from "@ant-design/icons";
import ContentEditable from "react-contenteditable";
import { ReactSVG } from "react-svg";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";

import "./CsvMapper.scss";
import InfoLabel from "../../Elements/InfoLabel";
import { DATE_FORMAT_FRONTEND, DATE_FORMAT_QUERY } from "../../../constants";
import { getTranslation } from "../../../utils/helper";
import { doUpdateUploadOrderTemplate } from "../../../modules/auth/stores/thunk";
import DefaultContactLocation from "./DefaultContactLocation";

const { Search } = Input;

const formatTime = time => {
  if (!isNaN(time) && time >= 0 && time < 1) {
    let hours = floor(24 * time);
    let mins = round((24 * time - hours) * 60);
    if (mins === 60) {
      mins = 0;
      hours = hours + 1;
    }
    if (hours > 23) {
      mins = 59;
      hours = 23;
    }
    return `${hours}:${String(mins).padStart(2, "0")}`;
  }
  return time;
};

const CsvMapperForm = ({ isFetching, template, data, onComplete, onCancel, allTemplate }) => {
  // const { setting } = useSelector((state) => state.setting);
  const dispatch = useDispatch();
  const user = useSelector(state => state.auth.user);
  const setting = user.company;

  const showFields = keys(template);
  const firstDataFields = data[0];

  // const pickup_phone = firstDataFields.pickup_phone?.toString();
  // const delivery_phone = firstDataFields.delivery_phone?.toString();
  // if (!isEmpty(pickup_phone) && !pickup_phone.includes("+")) {
  //   firstDataFields.pickup_phone = "+" + pickup_phone;
  // }
  // if (!isEmpty(delivery_phone) && !delivery_phone.includes("+")) {
  //   firstDataFields.delivery_phone = "+" + delivery_phone;
  // }
  if (!isEmpty(firstDataFields.pickup_from)) {
    firstDataFields.pickup_from = formatTime(firstDataFields.pickup_from);
  }
  if (!isEmpty(firstDataFields.pickup_to)) {
    firstDataFields.pickup_to = formatTime(firstDataFields.pickup_to);
  }
  if (!isEmpty(firstDataFields.delivery_from)) {
    firstDataFields.delivery_from = formatTime(firstDataFields.delivery_from);
  }
  if (!isEmpty(firstDataFields.delivery_to)) {
    firstDataFields.delivery_to = formatTime(firstDataFields.delivery_to);
  }

  const dataFields = Object.keys(firstDataFields);

  const mapping = showFields.map(item => {
    return matchedField(item);
  });

  if (!isEmpty(allTemplate["Fields"])) {
    const fieldsData = JSON.parse(allTemplate["Fields"]);
    const keyFields = Object.keys(fieldsData);
    if (keyFields.length > 0) {
      keyFields.forEach(kf => {
        let fields = [];
        let mappingValues = "";
        let mappingHtml = "";
        let fieldTemplate = fieldsData[kf] || "";

        if (fieldTemplate) {
          fields = convertTemplateToFields(fieldTemplate);
          forEach(fields, (tmp, index) => {
            if (!isMappingFieldValue(tmp)) {
              fields.splice(index, 1);
              fieldTemplate = fieldTemplate.replace(`[[${tmp}]]`, "");
            }
          });
          mappingHtml = convertTemplateToHtml(fieldTemplate, fields);
          mappingValues = convertHtmlToValues(mappingHtml, fields);
        }
        mapping.push({
          title: kf,
          template: fieldTemplate,
          mappingValues,
          mappingHtml,
          required: false,
          matched: false,
          moreField: true,
          errors: {},
        });
      });
    }
  }

  const [state, setState] = useState({
    mapping: mapping,
    visible: false,
    item_index: 0,
    searchedHeader: dataFields,
    visibleModal: false,
    contactType: null,
    contact: null,
  });

  const handleAddDefaultHeader = (field, titleField, dataField, index) => {
    if (field === titleField) {
      const translate = getTranslation(setting, "Orders", titleField);
      if (dataFields.includes(translate)) {
        addDefaultHeader(translate, index);
      } else if (dataFields.includes(dataField)) {
        addDefaultHeader(dataField, index);
      }
    }
  };

  useEffect(() => {
    showFields.forEach((field, index) => {
      if (!isEmpty(state.mapping[index].template)) return;
      handleAddDefaultHeader(field, "Pickup Name", "pickup_name", index);
      handleAddDefaultHeader(field, "Pickup Phone", "pickup_phone", index);
      handleAddDefaultHeader(field, "Pickup Email", "pickup_email", index);
      handleAddDefaultHeader(field, "Pickup Address", "pickup_address", index);
      handleAddDefaultHeader(field, "Pickup Latitude", "pickup_lat", index);
      handleAddDefaultHeader(field, "Pickup Longitude", "pickup_lng", index);
      handleAddDefaultHeader(field, "Pickup From", "pickup_from", index);
      handleAddDefaultHeader(field, "Pickup To", "pickup_to", index);
      handleAddDefaultHeader(field, "Pickup Duration", "pickup_duration", index);
      handleAddDefaultHeader(field, "Pickup Notes", "pickup_notes", index);
      handleAddDefaultHeader(field, "Delivery Name", "delivery_name", index);
      handleAddDefaultHeader(field, "Delivery Phone", "delivery_phone", index);
      handleAddDefaultHeader(field, "Delivery Email", "delivery_email", index);
      handleAddDefaultHeader(field, "Delivery Address", "delivery_address", index);
      handleAddDefaultHeader(field, "Delivery Latitude", "delivery_lat", index);
      handleAddDefaultHeader(field, "Delivery Longitude", "delivery_lng", index);
      handleAddDefaultHeader(field, "Delivery From", "delivery_from", index);
      handleAddDefaultHeader(field, "Delivery To", "delivery_to", index);
      handleAddDefaultHeader(field, "Delivery Duration", "delivery_duration", index);
      handleAddDefaultHeader(field, "Delivery Notes", "delivery_notes", index);
      handleAddDefaultHeader(field, "Order Ref", "order_ref", index);
      handleAddDefaultHeader(field, "User Group", "user_group", index);
      handleAddDefaultHeader(field, "Load", "load", index);
      handleAddDefaultHeader(field, "Types", "types", index);
    });
  }, []);

  // useEffect(() => {
  //   if (headers.length) {
  //     headers[headers.length - 1].focus();
  //   }
  //   // eslint-disable-next-line
  // }, [state.mapping.length]);

  function matchedField(item) {
    const matched = showFields.includes(item);
    let fields = [];
    let mappingValues = "";
    let mappingHtml = "";
    const field = template[item];
    let fieldTemplate = field.value || "";
    const isMatch = isMappingFieldValue(item);

    if (fieldTemplate) {
      fields = convertTemplateToFields(fieldTemplate);
      forEach(fields, (tmp, index) => {
        if (!isMappingFieldValue(tmp)) {
          fields.splice(index, 1);
          fieldTemplate = fieldTemplate.replace(`[[${tmp}]]`, "");
        }
      });
      mappingHtml = convertTemplateToHtml(fieldTemplate, fields);
      mappingValues = convertHtmlToValues(mappingHtml, fields);
    } else if (matched && isMatch) {
      fieldTemplate = `[[${item}]]`;
      mappingValues = mappingFieldValue(item);
      mappingHtml = htmlMappingField(item);
    }
    return {
      title: getTranslation(setting, "Orders", item),
      code: item,
      required: field.require,
      info: field.info,
      template: fieldTemplate,
      mappingValues,
      mappingHtml,
    };
  }

  function isMappingFieldValue(field) {
    return typeof firstDataFields[field] !== "undefined";
  }

  function mappingFieldValue(item) {
    // return item === 'Completed Date' ? moment(new Date(firstDataFields[item]), 'MM/DD/YYYY h:mm A').format('MM/DD/YYYY h:mm A') : firstDataFields[item];
    return firstDataFields[item];
  }

  function convertTemplateToFields(template) {
    const fields = [];
    const regex = /\[\[(.*?)\]\]/g;
    let m;
    while ((m = regex.exec(template)) !== null) {
      if (m.index === regex.lastIndex) {
        regex.lastIndex++;
      }
      forEach(m, match => {
        const field = match.replace("[[", "").replace("]]", "");
        fields.push(field);
      });
    }

    return fields;
  }

  function convertTemplateToHtml(template, fields) {
    let mappingHtml = template;
    forEach(fields, field => {
      mappingHtml = mappingHtml.replace(`\[\[${field}\]\]`, htmlMappingField(field));
    });
    return mappingHtml;
  }

  function convertHtmlToValues(html, fields) {
    let mappingValues = html;
    forEach(fields, field => {
      const item = htmlMappingField(field);
      const value = mappingFieldValue(field);
      mappingValues = mappingValues.replace(item, value);
    });
    mappingValues = mappingValues.replace(/&nbsp;/gi, " ");
    mappingValues = mappingValues.replace(/<div> <\/div>/gi, "");
    return mappingValues;
  }

  function convertHtmlToTemplate(html) {
    let template = html;
    const regex = /<span[^>]*>(.*?)<a[^>]*><\/a><\/span>/g;
    let m;

    while ((m = regex.exec(html)) !== null) {
      if (m.index === regex.lastIndex) {
        regex.lastIndex++;
      }
      const match = m[0];
      const field = m[1];
      template = template.replace(match, `[[${field}]]`);
    }

    return template;
  }

  function handleChangeMappingDate(value, index) {
    let mappingHtml = value?.format(DATE_FORMAT_QUERY) || "";
    mappingHtml = mappingHtml.replace(/&nbsp;/g, " ");
    mappingHtml = mappingHtml.replace(/<br>/g, " ");
    mappingHtml = mappingHtml.replace(/\s+/g, " ");
    handleChangeMappingField(mappingHtml, index);
  }

  function handleChangeMappingFields(evt, index) {
    let mappingHtml = evt.target.value;
    mappingHtml = mappingHtml.replace(/&nbsp;/g, " ");
    mappingHtml = mappingHtml.replace(/<br>/g, " ");
    mappingHtml = mappingHtml.replace(/\s+/g, " ");
    mappingHtml = mappingHtml.replace(/<div> <\/div>/gi, "");

    handleChangeMappingField(mappingHtml, index);
  }

  function handleChangeMappingFieldsClick(_evt, index) {
    const mapping = state.mapping;
    let mappingHtml = mapping[index].mappingHtml;
    mappingHtml = mappingHtml.replace(/<br>/g, " ");
    mappingHtml = mappingHtml.replace(/&nbsp;/g, " ");
    mappingHtml = mappingHtml.replace(/\s+/g, " ");
    mappingHtml = mappingHtml.replace(/<div> <\/div>/gi, "");
    mappingHtml = mappingHtml.trim() + "&nbsp;";
    mappingHtml = mappingHtml.trim() + " ";
    handleChangeMappingField(mappingHtml, index);
  }

  function handleChangeMappingField(mappingHtml, index) {
    const mapping = state.mapping;
    const field = mapping[index];
    field.template = convertHtmlToTemplate(mappingHtml);
    const fields = convertTemplateToFields(field.template);
    field.mappingHtml = mappingHtml;
    field.mappingValues = convertHtmlToValues(field.mappingHtml, fields);
    mapping[index] = field;
    setState({ ...state, mapping, visible: false });
  }

  function handleAddHeader(item) {
    const mapping = state.mapping;
    const field = mapping[state.item_index];
    const mappingHtml = (mapping[state.item_index].mappingHtml + " " + htmlMappingField(item)).trim();

    field.template = convertHtmlToTemplate(mappingHtml);
    const fields = convertTemplateToFields(field.template);
    field.mappingHtml = mappingHtml;
    field.mappingValues = convertHtmlToValues(field.mappingHtml, fields);
    if (includes(["Pickup From", "Pickup To", "Delivery From", "Delivery To"], field.title)) {
      field.mappingValues = formatTime(field.mappingValues);
    }
    if (includes(["Pickup Phone", "Delivery Phone"], field.title)) {
      if (!isEmpty(field.mappingValues) && !field.mappingValues.includes("+")) {
        field.mappingValues = "+" + field.mappingValues;
      }
    }

    mapping[state.item_index] = field;
    setState({ ...state, mapping });
  }

  function addDefaultHeader(item, index) {
    const mapping = state.mapping;
    const field = mapping[index];
    const mappingHtml = (mapping[index].mappingHtml + " " + htmlMappingField(item)).trim();

    field.template = convertHtmlToTemplate(mappingHtml);
    const fields = convertTemplateToFields(field.template);
    field.mappingHtml = mappingHtml;
    field.mappingValues = convertHtmlToValues(field.mappingHtml, fields);

    mapping[index] = field;
    setState({ ...state, mapping, visible: false });
  }

  function htmlMappingField(item) {
    return `<span class="MappingField" contenteditable="false">${item}<a class="btnDelete" onclick="var parent = this.parentNode.parentNode; this.parentNode.remove(); parent.blur();"></a></span>`;
  }

  function handleAddRowHeader() {
    const mapping = state.mapping;
    mapping.push({
      title: "",
      required: false,
      template: "",
      mappingValues: "",
      mappingHtml: "",
      matched: false,
      moreField: true,
      errors: {},
    });
    setState({ ...state, mapping });
  }

  function handleOpenSearchFields(index) {
    setState({ ...state, visible: true, item_index: index });
  }

  function handleCancel() {
    setState({ ...state, visible: false });
  }

  function handleCancelMapping() {
    onCancel();
  }

  async function handleDoneMapping() {
    const template = {};
    state.mapping
      .filter(s => !s.moreField)
      .map(mapping => {
        template[mapping.code] = {
          value: mapping.template,
          require: mapping.required,
        };
      });

    template["Fields"] = {};
    state.mapping
      .filter(s => s.moreField)
      .forEach(mapping => {
        template["Fields"][mapping.title] = mapping.template;
      });
    const uploadOrderTemplate = reduce(
      template,
      (result, value, key) => {
        if (!isEmpty(value) && key === "Fields") {
          result[key] = JSON.stringify(value);
          return result;
        }
        result[key] = value.value;
        return result;
      },
      {},
    );
    await dispatch(doUpdateUploadOrderTemplate({ uploadOrderTemplate }));
    onComplete(template);
  }

  function handleChangeInputName(e, index) {
    const mapping = state.mapping;
    mapping[index].title = e.target.value;
    setState({ ...state, mapping });
  }

  function onSeachHeader(e) {
    const searchedHeader = dataFields.filter(data_field =>
      data_field.toLowerCase().includes(e.target.value.toLowerCase()),
    );
    setState({ ...state, searchedHeader });
  }

  function handleOnClickRemove(index) {
    const mapping = state.mapping;
    mapping.splice(index, 1);
    setState({ ...state, mapping, item_index: 0 });
  }

  const handleUseDefaultLocation = (index, field) => {
    const type = field.includes("Pickup") ? "PICKUP" : "DELIVERY";
    setState({
      ...state,
      visibleModal: true,
      contactType: type,
      contact: null,
      index,
      field,
    });
  };

  const handleSubmitSelectContact = () => {
    if (state.contact) {
      if (state.contactType === "PICKUP") {
        handleChangeMappingField(state.contact?.name || "", findIndex(state.mapping, { code: "Pickup Name" }));
        handleChangeMappingField(state.contact?.phone || "", findIndex(state.mapping, { code: "Pickup Phone" }));
        handleChangeMappingField(state.contact?.address || "", findIndex(state.mapping, { code: "Pickup Address" }));
        handleChangeMappingField(state.contact?.lat || "", findIndex(state.mapping, { code: "Pickup Latitude" }));
        handleChangeMappingField(state.contact?.lng || "", findIndex(state.mapping, { code: "Pickup Longitude" }));
        handleChangeMappingField(state.contact?.startTime || "", findIndex(state.mapping, { code: "Pickup From" }));
        handleChangeMappingField(state.contact?.endTime || "", findIndex(state.mapping, { code: "Pickup To" }));
        handleChangeMappingField(
          state.contact?.duration?.toString() || "",
          findIndex(state.mapping, { code: "Pickup Duration" }),
        );
        handleChangeMappingField(
          state.contact?.notes?.toString() || "",
          findIndex(state.mapping, { code: "Pickup Notes" }),
        );
      }
      if (state.contactType === "DELIVERY") {
        handleChangeMappingField(state.contact?.name || "", findIndex(state.mapping, { code: "Delivery Name" }));
        handleChangeMappingField(state.contact?.phone || "", findIndex(state.mapping, { code: "Delivery Phone" }));
        handleChangeMappingField(state.contact?.address || "", findIndex(state.mapping, { code: "Delivery Address" }));
        handleChangeMappingField(state.contact?.lat || "", findIndex(state.mapping, { code: "Delivery Latitude" }));
        handleChangeMappingField(state.contact?.lng || "", findIndex(state.mapping, { code: "Delivery Longitude" }));
        handleChangeMappingField(state.contact?.startTime || "", findIndex(state.mapping, { code: "Delivery From" }));
        handleChangeMappingField(state.contact?.endTime || "", findIndex(state.mapping, { code: "Delivery To" }));
        handleChangeMappingField(
          state.contact?.duration?.toString() || "",
          findIndex(state.mapping, { code: "Delivery Duration" }),
        );
        handleChangeMappingField(
          state.contact?.notes?.toString() || "",
          findIndex(state.mapping, { code: "Delivery Notes" }),
        );
        handleChangeMappingField(state.contact?.load?.toString() || "", findIndex(state.mapping, { code: "Load" }));
      }
      // if (["Pickup Name", "Delivery Name"].includes(state.field)) {
      //   handleChangeMappingField(state.contact?.name, state.index);
      // }
      // if (["Pickup Phone", "Delivery Phone"].includes(state.field)) {
      //   handleChangeMappingField(state.contact?.phone, state.index);
      // }
      // if (["Pickup Address", "Delivery Address"].includes(state.field)) {
      //   handleChangeMappingField(state.contact?.address, state.index);
      // }
      // if (["Pickup From", "Delivery From"].includes(state.field)) {
      //   handleChangeMappingField(state.contact?.startTime, state.index);
      // }
      // if (["Pickup To", "Delivery To"].includes(state.field)) {
      //   handleChangeMappingField(state.contact?.endTime, state.index);
      // }
      // if (["Pickup Duration", "Delivery Duration"].includes(state.field)) {
      //   handleChangeMappingField(
      //     state.contact?.duration.toString(),
      //     state.index
      //   );
      // }
    }
    handleCancelSelectContact();
  };

  const handleCancelSelectContact = () => {
    setState({ ...state, visibleModal: false, contact: null });
  };

  const field = state.mapping[state.item_index];
  return (
    <div className="CsvMapperForm">
      <Spin spinning={isFetching}>
        <div className="FormContent">
          <div className="MappingContent">
            {state.mapping.map((item, index) => {
              return (
                <div className="Item" key={`item-${index}`}>
                  <Row gutter={16}>
                    <Col xs={{ span: 24 }} md={{ span: 5 }}>
                      <div className="TitleFields">
                        <div className="number"> {index + 1} </div>
                        <div className="content">
                          {!item.moreField ? (
                            <InfoLabel text={item.title} title={item.info} required={item.required} />
                          ) : (
                            <>
                              <EditOutlined />
                              <Input
                                onChange={e => handleChangeInputName(e, index)}
                                value={item.title}
                                placeholder="Header Name"
                                disable={item.required}
                              />
                            </>
                          )}
                        </div>
                      </div>
                    </Col>
                    <Col xs={{ span: 24 }} md={{ span: 16 }}>
                      <div className="MappingFields">
                        {item.code === "Date" ? (
                          <DatePicker
                            placeholder="Date"
                            format={DATE_FORMAT_FRONTEND}
                            onChange={value => handleChangeMappingDate(value, index)}
                            value={item.mappingValues ? moment(item.mappingValues) : ""}
                          />
                        ) : (
                          <ContentEditable
                            className="NameFields"
                            html={item.mappingHtml}
                            onChange={e => handleChangeMappingFields(e, index)}
                            onClick={e => handleChangeMappingFieldsClick(e, index)}
                          />
                        )}
                        <div className="ValueFields">{item.mappingValues.replace(/undefined/g, "")}</div>
                        {item.code !== "Date" && (
                          <div className="SelectFields" onClick={() => handleOpenSearchFields(index)}>
                            <Tooltip title="Search Header Data">
                              <div>{getTranslation(setting, "Orders", "Add Attribute")}</div>
                            </Tooltip>
                            <ReactSVG className="icon" src="/icons/add-attribute.svg" />
                          </div>
                        )}
                        {[
                          "Pickup Name",
                          "Pickup Phone",
                          "Pickup Address",
                          "Pickup Latitude",
                          "Pickup Longitude",
                          "Pickup From",
                          "Pickup To",
                          "Pickup Duration",
                          "Delivery Name",
                          "Delivery Phone",
                          "Delivery Address",
                          "Delivery Latitude",
                          "Delivery Longitude",
                          "Delivery From",
                          "Delivery To",
                          "Delivery Duration",
                        ].includes(item.code) && (
                          <div
                            className="UseDefaultLocation"
                            onClick={() => handleUseDefaultLocation(index, item.code)}>
                            {getTranslation(setting, "Orders", "Add from Contact List")}
                            <ReactSVG className="icon" src="/icons/default-location.svg" />
                          </div>
                        )}
                      </div>
                    </Col>
                    <Col xs={{ span: 24 }} md={{ span: 3 }}>
                      <div className="Notify">
                        {item.mappingValues && (
                          <Button type="link" className="btn-matched">
                            <CheckCircleOutlined />
                            {getTranslation(setting, "Orders", "Matched")}
                          </Button>
                        )}
                        {item.moreField && (
                          <Button
                            key="delete"
                            type="link"
                            onClick={() => handleOnClickRemove(index)}
                            className="btn-remove">
                            <ReactSVG className="icon" src="/icons/delete.svg" />
                          </Button>
                        )}
                      </div>
                    </Col>
                  </Row>
                </div>
              );
            })}
          </div>
          <div className="MappingFooter">
            <Button className="btn-add-header" onClick={() => handleAddRowHeader()}>
              {getTranslation(setting, "Orders", "Add Header")}
              <ReactSVG className="icon" src="/icons/add.svg" />
            </Button>
          </div>
        </div>
        <div className="FormFooter">
          <div className="Left"></div>
          <div className="Right">
            <Button key="cancel" className="btn-cancel" onClick={handleCancelMapping}>
              {getTranslation(setting, "Common", "Cancel")}
            </Button>
            <Button key="submit" type="primary" onClick={handleDoneMapping}>
              {getTranslation(setting, "Common", "Done")}
              <ReactSVG className="icon" src="/icons/submit.svg" />
            </Button>
          </div>
        </div>
      </Spin>
      <Modal
        open={state.visible}
        title={getTranslation(setting, "Orders", "Add Attribute")}
        className="SearchHeaderData"
        onCancel={handleCancel}
        footer={null}>
        <div className="ListHeader">
          <Search
            className="mb-3"
            placeholder={getTranslation(setting, "Orders", "Search Header")}
            onChange={e => onSeachHeader(e)}
          />
          <List>
            {state.searchedHeader.map((item, index) => {
              const isFound = field.template.indexOf(`[[${item}]]`);
              return (
                <List.Item key={index}>
                  <div className="content">
                    <div className="left">
                      <b>{item}</b>: {mappingFieldValue(item)}
                    </div>
                    <div className="right">
                      {isFound >= 0 && <Button type="link">{getTranslation(setting, "Orders", "Added")}</Button>}
                      {isFound < 0 && (
                        <Button key="submit" type="primary" onClick={() => handleAddHeader(item)}>
                          {getTranslation(setting, "Orders", "Add")}
                        </Button>
                      )}
                    </div>
                  </div>
                </List.Item>
              );
            })}
          </List>
        </div>
      </Modal>
      <Modal open={state.visibleModal} onCancel={handleCancelSelectContact} footer={[]} width={792}>
        <DefaultContactLocation
          state={state}
          setState={setState}
          handleCancel={handleCancelSelectContact}
          handleSubmit={handleSubmitSelectContact}
        />
      </Modal>
    </div>
  );
};

export default CsvMapperForm;
